import React from 'react';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import styled from 'styled-components';
import {getInitialCmsPageSharedValues, PageData, useCmsData} from 'epic-ue-shared';
import {Page, Section, HighlightPanel, CaseStudies} from 'epic-ue-components';
import {SectionWrapper, NewsContent, NewsSection} from './News.styles';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {UeThemeProvider, ueLightTheme} from 'epic-ue-theme';
import Error404 from '../error/Error404';

const cmsUrlPattern = '/news';

const News = styled.div`
    &.container {
        padding-left: 0;
        padding-right: 0;
    }
    margin-bottom: 4em;
`;

interface NewsPageData extends PageData {
    bgImg?: string;
    bottomContent?: any;
    content?: any;
    news?: any;
    showcase?: any;
}

interface Properties {}

const NewsView = (props: Properties): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<NewsPageData>(cmsUrlPattern);
    const bgImage = pageData.bgImg || '';
    const content = pageData.content || {};
    const bottomContent = pageData.bottomContent || {};
    const news = pageData.news || {};
    const panels = news.panels || [];
    const sections = content.sections || [];
    const bottomSections = bottomContent.sections || [];
    const showcase = pageData.showcase || {};

    if (cmsLoading) {
        return (
            <div className="news">
                {getHelmetForMetaTags(pageData)}
                <LoadIndicator />
            </div>
        );
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    let sectionList = <div />;
    if (sections) {
        sectionList = sections.map((section, i) => {
            let even = false;
            if (i % 2 === 0) {
                even = true;
            }
            return <Section key={`s-${i}-${section.title}`} {...section} even={even} />;
        });
    }

    let bottomSectionList = <div />;
    if (bottomSections) {
        bottomSectionList = bottomSections.map((section, i) => {
            let even = false;
            if (i % 2 === 0) {
                even = true;
            }
            return <Section key={`s-${i}-${section.title}`} {...section} even={even} />;
        });
    }

    let highlightList = <div />;
    if (panels) {
        highlightList = panels.map((panel, i) => {
            return (
                !panel.hidden && <HighlightPanel key={`highlight-${i}-${panel.title}`} {...panel} />
            );
        });
    }

    return (
        <Page>
            <News className="container">
                {getHelmetForMetaTags(pageData)}
                <UeThemeProvider theme={ueLightTheme}>
                    <NewsContent>
                        <SectionWrapper bgImg={bgImage}>{sectionList}</SectionWrapper>
                        <CaseStudies {...showcase} />
                        <NewsSection>{highlightList}</NewsSection>
                        <SectionWrapper bgImg="">{bottomSectionList}</SectionWrapper>
                    </NewsContent>
                </UeThemeProvider>
            </News>
        </Page>
    );
};

NewsView.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default NewsView;
